import styled from 'styled-components';

export const SharedStylePreserver = styled.span<{ corporateFont?: boolean }>`
    & > :is(h1, h2, h3, h4, p) {
        font-family: ${({ corporateFont }) => (corporateFont ? 'Corporate E' : 'unset')};
        font-weight: 700;
    }
`;
